import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {BlueButton, GreenButton, GreyButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {
    deleteIncidentNotification,
    incidentNotification,
    incidentNotificationRevision,
    saveOrUpdateIncidentNotification,
    uploadMultipleFiles, deleteFile, addIncidentNotificationRevision
} from "../../util/OperationModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Dropzone from "react-dropzone";
import {Table, TableHead} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import * as ApiUtils from "../../util/ApiUtils";
import SignaturePad from 'react-signature-canvas';
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    { name: t('incident.columns.identifier'), id: 'identifier', type: "text" },
    { name: t('incident.columns.date'), id: 'displayDate', type: "text" },
    { name: t('incident.columns.time'), id: 'displayTime', type: "text" },
    { name: t('incident.columns.location'), id: 'incidentLocation', type: "text" },
    { name: t('incident.columns.reportedBy'), id: 'reportedBy', type: "text" },
];

class IncidentNotificationTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            incidentNotification: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            show: false,
            date: null,
            showTime: null,
            identifier: "",
            incidentLocation: "",
            reportedBy: "",
            reportedByPhoneNumber: "",
            description: "",
            selectedFiles: [],
            trimmedDataURL: null,
        };
        this.loadIncidentNotification = this.loadIncidentNotification.bind(this);
        this.loadIncidentNotificationRevision = this.loadIncidentNotificationRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.deleteFileFromRecord = this.deleteFileFromRecord.bind(this);
        this.addRevision = this.addRevision.bind(this);
    }

    addRevision(request) {
        addIncidentNotificationRevision(request)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('messages.revisionUpdated'), 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    deleteFileFromRecord(fileId) {
        console.log("this.state.id", this.state.id);
        console.log("fileId", fileId);
        deleteFile("/incidentNotification/deleteFile", this.state.id, fileId)
            .then(() => {
                const remainingFiles = this.state.files.filter(function(file) {
                    return file.id !== fileId;
                });
                this.setState({
                    files: remainingFiles,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    onDrop(files) {
        let selectedFiles = this.state.selectedFiles;
        files.map(file => selectedFiles.push(file));
        this.setState({
            selectedFiles: selectedFiles
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    sigPad = {};

    componentDidMount() {
        this.loadIncidentNotification();
        this.loadIncidentNotificationRevision();
    }

    loadIncidentNotificationRevision() {
        incidentNotificationRevision()
            .then(response => {
                console.log(response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadIncidentNotification() {
        incidentNotification()
            .then(response => {
                console.log(response);
                this.setState({
                    incidentNotification: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(incidentNotification) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: incidentNotification.id,
            date: incidentNotification.date,
            header: `${incidentNotification.identifier}`,
            incidentLocation: incidentNotification.incidentLocation,
            reportedBy: incidentNotification.reportedBy,
            reportedByPhoneNumber: incidentNotification.reportedByPhoneNumber,
            description: incidentNotification.description,
            trimmedDataURL: incidentNotification.trimmedDataURL,
            files: incidentNotification.files,
        });
        if (incidentNotification.time) {
            this.setState({
                showTime: moment(incidentNotification.time, "HH:mm"),
                submitTime: incidentNotification.time,
            });
        }
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            date: null,
            showTime: null,
            identifier: "",
            incidentLocation: "",
            reportedBy: "",
            reportedByPhoneNumber: "",
            description: "",
            header: t('incident.newIncident'),
            trimmedDataURL: null,
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            date: null,
            showTime: null,
            identifier: "",
            incidentLocation: "",
            reportedBy: "",
            reportedByPhoneNumber: "",
            description: "",
            header: t('incident.newIncident'),
            selectedFiles: [],
            trimmedDataURL: null,
        });
        this.loadIncidentNotification();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deleteIncidentNotification(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success(t('app.notifications.success'), t('messages.incidentRemoved'), 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        this.setState({
                trimmedDataURL: this.sigPad.toDataURL('image/png'),
            },
        () => {
            console.log("state after updating", this.state);
            saveOrUpdateIncidentNotification(this.state)
                .then((updatedRecord) => {
                    if (this.state.selectedFiles.length > 0) {
                        uploadMultipleFiles("/incidentNotification/fileUpload", updatedRecord.id, this.state.selectedFiles, () => {
                            NotificationManager.success(t('app.notifications.success'), t('messages.incidentUpdated'), 5000);
                            this.reset();
                        });
                    } else {
                        NotificationManager.success(t('app.notifications.success'), t('messages.incidentUpdated'), 5000);
                        this.reset();
                    }
                }).catch(error => {
                console.log("error");
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
            });
        })
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    onTimeChange(event, time) {
        this.setState({
            ...this.state, submitTime: time.toString(),
        });

        this.setState({
            ...this.state, showTime: moment(time, "HH:mm"),
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            ...this.state, date: moment(date, "DD/MM/YYYY"),
        });
    }

    clear = () => {
        this.sigPad.clear()
    };

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = (state.latestRevision.id !== null);

        const fileNames = this.state.selectedFiles.map((file) => (
            <li key={file.name}>
                {file.name}
            </li>
        ));
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                { t('incident.title') }
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                    <CardHeader
                        action={
                            <BlueButton
                                 variant="contained"
                                 color="secondary"
                                 startIcon={<AddCircleOutlineTwoTone/>}
                                 onClick={this.showModal}
                                 size="small"
                                 style={{marginRight: '10px'}}
                                 disabled={isAuditor || isViewer}
                             >
                                { t('common.add') }
                             </BlueButton>
                        }
                        title={
                            <span style={{color: "darkblue"}}>
                                <p><b>{isRevision && `${t('context.common.revision')} ${state.latestRevision.number} ${t('context.common.author')}: ${state.latestRevision.author}`}</b></p>
                                <p><b>{ t('context.common.approvedFor') }: {state.latestRevision.approvedBy} {t('context.common.on')} {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                            </span>
                        }
                    />
                    :
                        <CardHeader
                            style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                            title={
                                <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                            }
                        />
                    )}
                    <CardContent>
                        {(!state.isEditing ?
                            <div>
                                {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/incidentNotification/export')} style={{ float: 'right', marginRight: "160px" }}>{ t('common.export') }</GreenButton>}
                                <TableComponent
                                    tableKey="incidentNotificationTable"
                                    data={state.incidentNotification}
                                    columns={columns}
                                    handleSubmit={this.handleSubmit}
                                    handleAddRow={this.handleAddRow}
                                    handleRowDel={this.onDelete}
                                    handleRowEdit={this.onEdit}
                                    allowAdd={isRevision && !isAuditor && !isViewer ? 'show' : 'disable'}
                                    pagination={true}
                                    allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                                />
                            </div>
                            :
                            <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                 <div>
                                     <MuiPickersUtilsProvider utils={MomentUtils}>
                                         <KeyboardDatePicker
                                             disableToolbar
                                             autoOk
                                             variant="inline"
                                             format="DD/MM/YYYY"
                                             margin="normal"
                                             id="date"
                                             label={ t('incident.labels.date') }
                                             name="date"
                                             value={state.date}
                                             onChange={ this.onDateChange }
                                             KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                             style={{ width: "300px"}}
                                         />
                                     </MuiPickersUtilsProvider>
                                 </div>
                                 <div style={{ paddingTop: "20px"}}>
                                     <MuiPickersUtilsProvider utils={MomentUtils}>
                                         <KeyboardTimePicker
                                             margin="normal"
                                             id="time"
                                             label={ t('incident.labels.time') }
                                             format="HH:mm"
                                             value={state.showTime}
                                             onChange={this.onTimeChange}
                                             KeyboardButtonProps={{ 'aria-label': 'change time' }}
                                         />
                                     </MuiPickersUtilsProvider>
                                 </div>
                                 <div style={{ paddingTop: "20px"}}>
                                     <TextField
                                         id="incidentLocation"
                                         name="incidentLocation"
                                         value={state.incidentLocation}
                                         label={ t('incident.labels.location') }
                                         onChange={this.handleTextChange}
                                         style={{ width: "600px"}}
                                     />
                                 </div>
                                 <div style={{ paddingTop: "20px"}}>
                                     <TextField
                                         id="reportedBy"
                                         name="reportedBy"
                                         value={state.reportedBy}
                                         label={ t('incident.labels.reportedBy') }
                                         multiline
                                         rows={3}
                                         onChange={this.handleTextChange}
                                         style={{ width: "600px"}}
                                     />
                                 </div>
                                 <div style={{ paddingTop: "20px"}}>
                                     <TextField
                                         id="standard-multiline-static"
                                         label={ t('incident.labels.reportedByPhone') }
                                         name="reportedByPhoneNumber"
                                         value={state.reportedByPhoneNumber}
                                         onChange={this.handleTextChange}
                                         style={{ width: "800px"}}
                                     />
                                 </div>
                                 <div style={{ paddingTop: "20px"}}>
                                     <TextField
                                         id="standard-multiline-static"
                                         label={ t('incident.labels.rootCause') }
                                         name="rootCause"
                                         value={state.rootCause}
                                         onChange={this.handleTextChange}
                                         multiline
                                         rows="4"
                                         style={{ width: "800px"}}
                                     />
                                 </div>
                                 <div style={{ paddingTop: "20px"}}>
                                     <TextField
                                         id="standard-multiline-static"
                                         label={ t('incident.labels.description') }
                                         name="description"
                                         value={state.description}
                                         onChange={this.handleTextChange}
                                         multiline
                                         rows="4"
                                         style={{ width: "800px"}}
                                     />
                                 </div>
                             {
                                (state.files && state.files.length > 0) &&
                                    <div style={{ width: "800px", paddingTop: "30px" }}>
                                        <Table>
                                            <TableHead>
                                                <tr style={{ float: "left" }}>
                                                    <th colSpan={3} style={{ textAlign: "center" }}>{ t('incident.uploadedDocuments') }</th>
                                                </tr>
                                            </TableHead>
                                            <TableBody>
                                                {console.log('here 1', state.files)}
                                                {state.files.map((file) => (
                                                    <tr key={file.id}>
                                                        <td>{file.name}</td>
                                                        <td><GreyButton onClick={() => ApiUtils.downloadFile(file.id)}>{ t('common.download') }</GreyButton></td>
                                                        <td><RedButton onClick={() => this.deleteFileFromRecord(file.id)}>{ t('common.remove') }</RedButton></td>
                                                     </tr>
                                                 ))}
                                             </TableBody>
                                         </Table>
                                     </div>
                             }
                                 <div style={{ width: "800px", minHeight: "100px", paddingTop: "30px"}}>
                                    <Dropzone onDrop={this.onDrop}>
                                        {({getRootProps, getInputProps}) => (
                                        <div {...getRootProps()} style={{ border: '2px dotted #cccccc', padding: '20px', marginTop: '20px' }}>
                                            <input {...getInputProps()} />
                                            <p>{ t('incident.dragDropHint') }</p>
                                        </div>
                                        )}
                                    </Dropzone>
                                </div>
                                <div style={{ width: "400px", height: "360px", paddingTop: "30px" }}>
                                    <label>
                                        { t('incident.signaturePrompt') }
                                    </label>
                                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                        <SignaturePad
                                            canvasProps={{ width: "400px", height: "300px" }}
                                            ref={(ref) => {
                                                this.sigPad = ref;
                                                if (state.trimmedDataURL && this.sigPad) {
                                                    this.sigPad.fromDataURL(state.trimmedDataURL, { width: 400, height: 300})
                                                }
                                            }}
                                        />
                                        <GreyButton onClick={this.clear}>
                                            { t('common.clear') }
                                        </GreyButton>
                                    </div>
                                </div>
                                <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                    <OrangeButton
                                     variant="contained"
                                     color="secondary"
                                     startIcon={<AddCircleTwoTone />}
                                     size="small"
                                     onClick={this.onCancel}

                                     style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                 >
+                                        { t('common.cancel') }
                                 </OrangeButton>
                                 <GreenButton
                                     variant="contained"
                                     color="secondary"
                                     startIcon={<AddCircleTwoTone />}
                                     size="small"
                                     onClick={this.onSave}
                                     style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                 >
+                                        { t('common.save') }
                                  </GreenButton>
                                </div>
                            </div>
                        )}
                    </CardContent>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            </Paper>
            <NotificationContainer/>
        </div>
    }
}

export default withStyles(classes)(IncidentNotificationTemplate);
